import type { RiskTier } from '../domain/types';
import styles from './RiskBadge.module.css';

const LABELS: Record<RiskTier, string> = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH',
};

export function RiskBadge({ tier, size = 'md' }: { tier: RiskTier; size?: 'sm' | 'md' | 'lg' }) {
  const cls = [styles.badge, styles[tier.toLowerCase()], styles[size]]
    .filter(Boolean)
    .join(' ');
  return (
    <span className={cls} aria-label={`Risk tier ${LABELS[tier]}`}>
      {LABELS[tier]}
    </span>
  );
}
